import { render, staticRenderFns } from "./AddTags.vue?vue&type=template&id=6d67b704"
import script from "./AddTags.vue?vue&type=script&lang=js"
export * from "./AddTags.vue?vue&type=script&lang=js"
import style0 from "./AddTags.vue?vue&type=style&index=0&id=6d67b704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports